module.exports = __webpack_public_path__ + "images/trading-online-voucher-example-uses-1200w.png";